<template>
  <div class="pm-dialog-order-type">
    <div class="flex justify-center outer-area">
      <div class="vs-col">
        <div class="time-input-area">
          <vs-input-number
            placeholder="----"
            v-model="year"
            class="time-input"
            :min="0"
            :max="9999"
          />年
          <vs-input-number
            placeholder="--"
            v-model="month"
            class="time-input"
            :min="1"
            :max="12"
          />月
          <vs-input-number
            placeholder="--"
            v-model="date"
            class="time-input"
            :min="1"
            :max="validDay(year, month)"
          />日
          <vs-input-number
            placeholder="--"
            v-model="hour"
            class="time-input"
            :min="0"
            :max="23"
          />:
          <vs-input-number
            placeholder="--"
            v-model="minutes"
            class="time-input"
            :min="0"
            :max="59"
          />
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button class="button" color="#2E87B9" @mousedown="closePopup">
        <span class="button-text">キャンセル</span>
      </vs-button>
      <vs-button
        class="button"
        color="#2E87B9"
        @mousedown="onSubmit(isUpdateTimeStamp)"
      >
        <span class="button-text">保存</span>
      </vs-button>
    </div>
  </div>
</template>

<script>
/*
 * 入出港予定一覧画面（白色ではなく黒色画面）で、年月日、時間を編集する
 * @parent CellSummaryDialog.vue
 * @props columnKey: String カラム名を特定するためのキー。const.jsのCOL_NAMEの中の、columnKey
 *        valueMap : String 現在表示している値。
 *        taskId: String 一覧画面で表示する一行のデータにふられたID
 *        closePopup: ポップアップを閉じる関数
 */

import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("gkmgPortMasterDestinationWork");
import moment from "moment-timezone";

export default {
  name: "O.DialogDateInput",
  props: {
    taskId: { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap: { type: Object, required: true },
    closePopup: { type: Function, required: true },
  },
  data() {
    return {
      year: null,
      month: null,
      date: null,
      hour: null,
      minutes: null,
      connectedTime: null, // year, month, date, hour, minutesをまとめたもの

      isUpdateTimeStamp: null,
    };
  },
  computed: {
    ...mapState({
      summaryDialogShowPopup: (state) => state.summaryDialogShowPopup,
    }),
  },
  watch: {
    summaryDialogShowPopup() {
      if (this.summaryDialogShowPopup) {
        this.initData();
      }
    },
    year() {
      const maxDay = this.validDay(this.year, this.month);
      if (maxDay < this.date) {
        this.date = maxDay;
      }
    },
    month() {
      const maxDay = this.validDay(this.year, this.month);
      if (maxDay < this.date) {
        this.date = maxDay;
      }
    },
  },
  methods: {
    validDay(y, m) {
      const year = Number(y);
      const month = Number(m);
      if (isNaN(year) || isNaN(month)) return 31;

      if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
        return 31;
      } else if ([4, 6, 9, 11].includes(month)) {
        return 30;
      } else if (month === 2) {
        if (this.isLeap(year)) {
          return 29;
        } else {
          return 28;
        }
      } else {
        return 31;
      }
    },
    isLeap(year) {
      /*
       * 閏年
       * １）西暦が４で割り切れる年は閏年
       * ２）１）の例外として、西暦年号が100で割り切れて400で割り切れない年は平年
       */
      if (year % 4 !== 0) {
        // 4で割り切れない場合は平年（28日）
        return false;
      } else {
        // 100で割り切れるが400で割り切れない場合は平年(false)。そうでなければ閏年(true)。
        return !(year % 100 === 0 && year % 400 !== 0);
      }
    },
    initData() {
      this.connectedTime = this.valueMap.itSelf
        ? moment(this.valueMap.itSelf * 1000)
            .local()
            .format("YYYYMMDD HH:mm")
        : null;

      this.year = this.connectedTime ? this.connectedTime.slice(0, 4) : null;
      this.month = this.connectedTime ? this.connectedTime.slice(4, 6) : null;
      this.date = this.connectedTime ? this.connectedTime.slice(6, 8) : null;
      this.hour = this.connectedTime ? this.connectedTime.slice(9, 11) : null;
      this.minutes = this.connectedTime
        ? this.connectedTime.slice(12, 14)
        : null;

      this.isUpdateTimeStamp =
        this.valueMap.changes && this.valueMap.changes[String(this.columnKey)]
          ? true
          : false;
    },
    createTimeSubmitData() {
      const submitTimeData = `${this.year}-${this.month}-${this.date} ${this.hour}:${this.minutes}:00`;
      return new Date(submitTimeData);
    },
    onSubmit(isUpdateTimeStamp) {
      /*
       * onSubmit(false)    : 保存
       * onSubmit(true)     : ハイライト保存
       */
      const mode = [];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp");
      const updateKeyValueMap = {};

      const submitData = this.createTimeSubmitData();
      updateKeyValueMap[this.columnKey] = submitData;

      updateKeyValueMap["updated_at"] = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );

      this.$emit("updateValue", this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-order-type {
  .outer-area {
    padding-bottom: 1rem;
  }
  .candidate-item {
    min-width: 5rem;
    padding-left: 0 !important;
    padding-right: 0 !important;

    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;
  }

  ::v-deep .vs-input-number--button-less {
    display: none !important;
  }
  ::v-deep .vs-input-number--button-plus {
    display: none !important;
  }

  .button {
    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;
    cursor: pointer;
  }

  .button-text {
    width: 32px;
    height: 24px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */
    align-items: center;
    text-align: center;

    color: #f2f2f2;
  }
  .text-input {
    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;

    align-items: center;
    display: flex;
    text-align: center;

    color: #4f4f4f;
    background-color: #f2f2f2;
    border: none;
  }

  .time-input-area {
    width: 230px;
    height: 46px;
    margin: 0.2rem 1rem 0.2rem 1rem !important;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }
  .time-input {
    width: 16px;
    height: 46px;
    color: #4f4f4f;
    background-color: #f2f2f2;
    border: none;
    text-align: center;
  }
}
</style>
